export default "/_next/static/fonts/a3f1bb4cba76470189ca45a6a4c40c7a.ttf";